<p-dialog
    data-testid="team-member-delete-dialog"
    [(visible)]="deleteDialogVisible"
    [modal]="true"
    [closable]="true"
    header="{{ 'user_delete_confirm_header' | translate }}"
>
    <div class="mb-6">
        <p
            class="mb-2"
            [innerHTML]="'user_delete_confirm' | translate: { userName: selectedUserToDelete?.firstName + ' ' + selectedUserToDelete?.lastName }"
        ></p>
        <p-message severity="warn" class="mb-2">
            <div class="flex flex-col">
                <span class="p-message-summary text-md font-bold">{{ "user_deletion_warning_header" | translate }}</span>
                <span>{{ "user_deletion_warning_desc" | translate }}</span>
            </div>
        </p-message>
    </div>

    <form [formGroup]="deleteForm">
        <div class="p-field">
            <input
                id="deleteConfirm"
                type="text"
                pInputText
                formControlName="deleteConfirmation"
                data-testid="team-member-delete-challenge"
                class="p-inputtext p-component w-full"
                placeholder="{{ 'delete_challenge_placeholder' | translate }}"
            />

            <p-message severity="error" variant="simple" *ngIf="deleteConfirmation?.invalid && deleteConfirmation?.touched">
                {{ "delete_challenge_validation_label" | translate }}
            </p-message>
        </div>

        <div class="flex justify-between mt-12 mb-0 pb-0">
            <button
                type="submit"
                pButton
                label="{{ 'button_cancel' | translate }}"
                severity="secondary"
                class="p-button-text"
                (click)="closeDeleteDialog()"
            ></button>

            <button
                type="submit"
                pButton
                severity="danger"
                class="delayed-loading-btn"
                (click)="startDeleteLoading()"
                data-testid="team-member-delete-confirm"
                [disabled]="deleteForm.invalid || loadingCB || loading"
                [loading]="loading"
            >
                <i class="pi pi-trash"></i>
                <span class="ml-2">{{ "delete_member_confirm" | translate }}</span>
            </button>
        </div>
    </form>
</p-dialog>

<div class="card" *ngIf="getLoadingState() == 2">
    <p-message *ngIf="minLicenceMessage" severity="warn" text="{{ 'user_licenseFreelancerWarning' | translate }}" styleClass="mb-8 mt-6"></p-message>

    <p-table
        data-testid="team-members-table"
        #dt1
        [value]="users"
        [globalFilterFields]="['email', 'firstName', 'lastName']"
        dataKey="id"
        selectionMode="single"
        responsiveLayout="scroll"
        sortMode="multiple"
        [(selection)]="selectedUser"
        (onRowSelect)="onRowSelect($event)"
        [paginator]="true"
        [rows]="50"
        [rowsPerPageOptions]="[10, 25, 50, 100, 250]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'table_pagination_showing' | translate }} {first} {{ 'table_pagination_to' | translate }} {last} {{
            'table_pagination_of' | translate
        }} {totalRecords} {{ 'table_pagination_entries' | translate }}"
    >
        <ng-template pTemplate="caption">
            <div class="flex justify-between items-center">
                <div class="flex gap-2">
                    <p-select
                        data-testid="team-member-status-filter"
                        [options]="userStatusOptions"
                        [(ngModel)]="selectedUserStatus"
                        (onChange)="toggleUserStatus()"
                        placeholder="{{ 'user_status_filter' | translate }}"
                        class="user-status-dropdown"
                    />
                    <div class="flex items-center gap-2">
                        <p-iconfield>
                            <p-inputicon>
                                <i class="pi pi-search"></i>
                            </p-inputicon>
                            <input
                                data-testid="team-member-search"
                                pInputText
                                type="text"
                                [(ngModel)]="search"
                                placeholder="{{ 'user_search' | translate }}"
                                class="w-full"
                            />
                        </p-iconfield>
                    </div>
                    <button pButton type="button" class="p-button-text" (click)="showUserRolesInfoWindow()">
                        <i class="pi pi-info-circle"></i> {{ "user_role_info_open" | translate }}
                    </button>
                </div>

                <div class="flex items-center gap-2">
                    <div class="flex items-center gap-2">
                        <div class="flex justify-end">
                            @if (displayLicenseCounter) {
                                <div class="flex items-center mr-4 font-semibold">{{ "user_licenseActiveLicenses" | translate }} {{ licenses }}</div>
                            }
                            @if (currentUser?.hasPermissionStr("MANAGE_SUBSCRIPTION")) {
                                <button pButton type="button" (click)="goToLicenses()" class="p-button-text mr-2">
                                    {{ "upgrade_account" | translate }}
                                </button>
                            }
                            @if (currentUser?.hasPermissionStr("USER_CREATE")) {
                                <button data-testid="team-member-invite" pButton type="button" (click)="openAddUserDialog()" class="icon-button-fix">
                                    <i class="pi pi-user-plus"></i> {{ "team_member_invite" | translate }}
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="email">
                    {{ "user_email" | translate }}
                    <p-sortIcon field="email"> </p-sortIcon>
                </th>
                <th pSortableColumn="firstName">
                    {{ "user_firstname" | translate }}
                    <p-sortIcon field="firstName"> </p-sortIcon>
                </th>
                <th pSortableColumn="lastName">
                    {{ "user_lastname" | translate }}
                    <p-sortIcon field="lastName"> </p-sortIcon>
                </th>
                <th pSortableColumn="permissions">
                    {{ "user_role" | translate }}
                    <p-sortIcon field="permissions"> </p-sortIcon>
                </th>
                <th>{{ "group_option" | translate }}</th>
                <!-- <th pSortableColumn="state">{{ "user_status" | translate }} <p-sortIcon field="state">
                    </p-sortIcon>
                    </th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user let-editing="editing" let-ri="rowIndex">
            <tr [pSelectableRow]="user" [attr.data-testid]="'team-member-row-' + user.id">
                <td>{{ user.email }}</td>
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ giveRoletoPermissionSet(user) }}</td>
                <td>
                    <div class="chip-container">
                        <ng-container *ngFor="let groupName of userGroupsMap.get(user.id)">
                            <p-chip icon="pi pi-users" label="{{ groupName }}"></p-chip>
                        </ng-container>
                    </div>
                </td>
                <!-- <td>
                    {{user.state}}
                    </td> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft"> </ng-template>
        <ng-template pTemplate="paginatorright"> </ng-template>
    </p-table>
</div>

<div *ngIf="getLoadingState() == 1">
    <div class="mb-16 flex justify-center">
        <div class="mt-20">
            <div class="text-center items-center">
                <div class="mt-1">
                    <img class="inline" src="{{ 'user_nodata_link' | translate }}" width="65%" height="65%" alt="No data" />
                </div>
                <div class="mb-6">
                    <h4>{{ "user_nodata_title" | translate }}</h4>
                    <p [innerHTML]="'user_nodata_text' | translate"></p>
                </div>

                <div class="mb-16">
                    <p-button
                        data-testid="team-member-invite"
                        severity="primary"
                        pRipple
                        type="button"
                        styleClass="p-button-xl icon-button-fix"
                        (click)="openAddUserDialog()"
                        label="{{ 'user_nodata_button_text' | translate }}"
                        icon="pi pi-user-plus"
                    >
                    </p-button>
                </div>
                <div>
                    <p class="mt-16 mb-16">
                        <label style="color: #818181">{{ "tiles_nodata_text4" | translate }} </label>
                        <a [routerLink]="['/help']" [queryParams]="{ index: '2' }">{{ "tiles_nodata_text5" | translate }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-16"></div>
    <div class="mb-16"></div>
</div>

<!-- Window: create/edit user -->
<p-dialog
    data-testid="team-member-dialog"
    header="{{ getDialogHeader() }}"
    [(visible)]="showAddEditDialog"
    [modal]="true"
    [draggable]="true"
    [resizable]="false"
    (onHide)="selectedUser = undefined"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '550px' }"
>
    <div class="p-fluid">
        <div class="w-full mb-6">
            <label class="block mb-2" for="email">{{ "profile_email" | translate }} *</label>
            <input
                id="email"
                type="email"
                [(ngModel)]="newUserEmail"
                data-testid="team-member-email"
                [disabled]="isSelectedUserInactive"
                placeholder="{{ 'placeholder_enter_email' | translate }}"
                pInputText
                (input)="checkEmail($event)"
                autofocus
                class="w-full"
            />
        </div>
        <div *ngIf="!!emailChanged" class="flex field">
            <p>{{ "user_password_reset" | translate }}</p>
        </div>
        <div class="grid grid-cols-12 gap-4 mb-6">
            <div class="field col-span-6">
                <label class="block mb-2" for="firstname">{{ "profile_firstname" | translate }} *</label>
                <input
                    [disabled]="isSelectedUserInactive"
                    id="firstname"
                    type="text"
                    placeholder="{{ 'placeholder_firstname' | translate }}"
                    [(ngModel)]="newUserFirstname"
                    data-testid="team-member-first-name"
                    pInputText
                />
            </div>
            <div class="field col-span-6">
                <label class="block mb-2" for="lastname">{{ "profile_lastname" | translate }} *</label>
                <input
                    [disabled]="isSelectedUserInactive"
                    id="lastname"
                    type="text"
                    placeholder="{{ 'placeholder_lastname' | translate }}"
                    [(ngModel)]="newUserLastname"
                    data-testid="team-member-last-name"
                    pInputText
                />
            </div>
        </div>
        <div class="w-full mb-6">
            <label class="block mb-2" for="role">{{ "user_role" | translate }}</label>
            <div class="w-full" pTooltip="{{ 'user_role_proFeature' | translate }}" [tooltipDisabled]="isPro ?? false" tooltipPosition="top">
                <p-select
                    data-testid="team-member-role"
                    id="role"
                    class="w-full"
                    [options]="roles"
                    [(ngModel)]="newUserRole"
                    [disabled]="selectedUser?.id === currentUser?.id || !isPro || isSelectedUserInactive"
                />
            </div>
        </div>

        <!-- groups dropdown here -->
        @if (usersOriginal.length > 1) {
            <div class="w-full mb-6">
                <label class="block mb-2" for="groups">{{ "group_option" | translate }}</label>
                <div class="w-full" pTooltip="{{ 'upgrade_to_pro_for_groups' | translate }}" [tooltipDisabled]="!!isPro" tooltipPosition="top">
                    <p-multiSelect
                        data-testid="team-member-groups"
                        [disabled]="isSelectedUserInactive || !isPro"
                        id="groups"
                        class="w-full"
                        [options]="groups"
                        [(ngModel)]="selectedGroups"
                        optionLabel="name"
                        placeholder="{{ 'no_group_selection' | translate }}"
                        display="chip"
                        emptyMessage="{{ 'no_groups_created' | translate }}"
                        emptyFilterMessage="{{ 'no_results_found' | translate }}"
                        appendTo="body"
                    ></p-multiSelect>
                </div>
            </div>
        }
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-between w-full">
            <div>
                @if (!selUserIsCurrUser) {
                    @if (selectedUserStatus === UserState.Active && !newUser) {
                        <button
                            type="submit"
                            pButton
                            severity="secondary"
                            (click)="confirmUserStateChange(UserState.Inactive)"
                            data-testid="team-member-deactivate"
                            class="p-button-text"
                            [disabled]="loading"
                        >
                            <i class="pi pi-ban"></i> {{ "deactivate_user" | translate }}
                        </button>
                    }

                    @if (selectedUserStatus === UserState.Inactive && !newUser) {
                        <button
                            data-testid="team-member-delete"
                            type="submit"
                            pButton
                            severity="danger"
                            (click)="confirmDeleteUser()"
                            class="p-button-text"
                            [disabled]="loading"
                        >
                            <i class="pi pi-trash"></i> {{ "button_delete_user" | translate }}
                        </button>
                    }
                }
            </div>
            <div>
                <button
                    data-testid="team-member-cancel"
                    type="submit"
                    pButton
                    (click)="showAddEditDialog = false"
                    class="p-button-text mr-2"
                    severity="secondary"
                >
                    {{ "button_cancel" | translate }}
                </button>
                <button
                    data-testid="team-member-save"
                    type="submit"
                    pButton
                    [loading]="loading"
                    (click)="isActivateAction() ? confirmUserStateChange(UserState.Active) : addOrEditUser()"
                    iconPos="left"
                    [disabled]="isPrimaryDialogButtonDisabled()"
                >
                    <i [class]="isActivateAction() ? '' : 'pi pi-save'"></i>
                    {{ isActivateAction() ? ("activate_user" | translate) : getDialogButton() }}
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- Window: user roles info -->
<p-dialog
    header="{{ 'user_role_info_pop-up-heading' | translate }}"
    [(visible)]="showUserRolesInfo"
    [modal]="true"
    [draggable]="true"
    [resizable]="false"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '80vw' }"
>
    <p>{{ "user_role_info_text1" | translate }}</p>
    <p>{{ "user_role_info_text2" | translate }}</p>

    <p-table [value]="userRolesInfoTable" responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th class="text-xs"></th>
                <th class="text-xs text-center">
                    {{ "user_role_info_track_time" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_track_time_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_access_own_data" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_access_own_data_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_access_team_data" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_access_team_data_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_create_tiles" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_create_tiles_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_create_reports" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_create_reports_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_manage_team" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_manage_team_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_configure_layers" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_configure_layers_tooltip' | translate }}"></i>
                </th>
                <th class="text-xs text-center">
                    {{ "user_role_info_manage_payment" | translate
                    }}<i class="pi pi-info-circle ml-1 leading-normal" pTooltip="{{ 'user_role_info_manage_payment_tooltip' | translate }}"></i>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-userRolesInfo>
            <tr>
                <td>
                    <strong>{{ userRolesInfo.Title }}</strong>
                </td>
                <td class="text-center">{{ userRolesInfo.TrackTime }}</td>
                <td class="text-center">{{ userRolesInfo.AccessOwnData }}</td>
                <td class="text-center">{{ userRolesInfo.AccessTeamData }}</td>
                <td class="text-center">{{ userRolesInfo.CreateReports }}</td>
                <td class="text-center">{{ userRolesInfo.CreateTiles }}</td>
                <td class="text-center">{{ userRolesInfo.ConfigureLayers }}</td>
                <td class="text-center">{{ userRolesInfo.ManageTeam }}</td>
                <td class="text-center">{{ userRolesInfo.ManagePayments }}</td>
            </tr>
        </ng-template>
    </p-table>

    <p-message *ngIf="!isPro" severity="info" text="{{ 'user_role_info_text3' | translate }}" styleClass="mr-2 mt-6"> </p-message>

    <ng-template pTemplate="footer"> </ng-template>
</p-dialog>
